export const makeSquareImage = (base64Image: string): Promise<string> => {
  return new Promise(resolve => {
    const img = new Image();
    img.src = base64Image;

    img.onload = () => {
      const size = Math.min(img.width, img.height);

      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext('2d');
      if (!ctx) return resolve(base64Image);

      const offsetX = (img.width - size) / 2;
      const offsetY = (img.height - size) / 2;

      ctx.drawImage(img, offsetX, offsetY, size, size, 0, 0, size, size);
      resolve(canvas.toDataURL('image/jpeg', 1.0));
    };
  });
};
